import { useAuthStore } from '@/stores/auth'

const jwtHelper = {
    makeHttpAuthorization: makeHttpAuthorization    
}

function makeHttpAuthorization() {
    const authStore = useAuthStore()
    return {
        'Authorization': `Bearer ${authStore.user.token}`
    }
}

export default jwtHelper